// Checkout add-ons — website copy of the rules in bloom-backend/addons.js (keep the two identical; addons.test.mjs checks them
// against each other). See that file for the full description.
export const MAX_ADDONS = 8, MAX_NAME = 40, MAX_PRICE = 10000;
const ID_RE = /^[A-Za-z0-9_-]{3,48}$/;
const newId = () => "ao-" + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

export function sanitizeAddonList(input) {
  if (!Array.isArray(input)) return [];
  const out = [], seen = new Set();
  for (const a of input) {
    if (!a || typeof a !== "object") continue;
    const name = String(a.name == null ? "" : a.name).replace(/\s+/g, " ").trim().slice(0, MAX_NAME);
    const priceNum = Number(a.price);
    if (!name || !Number.isFinite(priceNum) || priceNum < 0 || priceNum > MAX_PRICE) continue;
    let id = typeof a.id === "string" && ID_RE.test(a.id) ? a.id : newId();
    while (seen.has(id)) id = newId();
    seen.add(id);
    const image = typeof a.image === "string" && /^https:\/\/\S{1,480}$/.test(a.image.trim()) ? a.image.trim() : "";
    out.push({ id, name, price: Math.round(priceNum), image, active: a.active !== false });
    if (out.length >= MAX_ADDONS) break;
  }
  return out;
}
export const activeAddons = (list) => sanitizeAddonList(list).filter(a => a.active);
export function resolveAddons(configList, ids) {
  const want = new Set((Array.isArray(ids) ? ids : []).map(String));
  return activeAddons(configList).filter(a => want.has(a.id));
}
export const addonsTotal = (resolved) => (Array.isArray(resolved) ? resolved : []).reduce((s, a) => s + (Number(a.price) || 0), 0);
